import './src/sass/common.scss'

const mainContentEl = document.querySelector('.main-content');
if(mainContentEl) {
	const classList = mainContentEl.classList;
	if(classList.contains('projects-page'))
	{
		import('./src/components/projects/index');
	}
	// else if(classList.contains('project-view-page'))
	// {
	// 	import('./src/components/project/index');
	// }
	else if(classList.contains('publications-page-main'))
	{
		import('./src/components/publications/index');
	}
	else if(classList.contains('publications-page-covid'))
	{
		import('./src/components/publications-covid/index');
	}
	else if(classList.contains('publications-page-taxcode'))
	{
		import('./src/components/publications-taxcode/index');
	}
	else if(classList.contains('js-state-of-war'))
	{
		import('./src/components/publications-war/index');
	}
  else if(classList.contains('js-defense'))
  {
    import('./src/components/publications-defense/index');
  }
	else if(classList.contains('publication-view-page-main'))
	{
		import('./src/components/publication/index');
	}
	else if(classList.contains('publication-view-page-taxcode'))
	{
		import('./src/components/publication-taxcode/index');
	}
	else if(classList.contains('js-state-of-war-item'))
	{
		import('./src/components/publication-war/index');
	}
  else if(classList.contains('js-defense-item'))
  {
    import('./src/components/publication-defense/index');
  }
	else if(classList.contains('team-page'))
	{
		import('./src/components/team/index');
	}
}

import('./src/components/search/index');
